export default __webpack_public_path__ + "static/media/EM1450.34I-37420_-22063_0.2051db9a.jpg";